import { privateAxios } from "@src/axios.config"

export const ManageCandidateProfile = async (data) => {
    return await privateAxios.post(`/api/users/create-user-profile`, data)
}

export const ManageEmployeeProfile = async (data) => {
    return await privateAxios.post(`/api/users/create-employer-profile`, data)
}

export const AddConnection = async (data) => {
    return await privateAxios.post(`/api/connections/`, data)
}

export const BlockConnection = async (connectionId) => {
    const response = await privateAxios.patch(`/api/connections/${connectionId}/block/`);
    return response;
}

export const UnblockConnection = async (connectionId) => {
    const response = await privateAxios.patch(`/api/connections/${connectionId}/unblock/`);
    return response;
}

export const DeleteConnection = async (connectionId) => {
    return await privateAxios.delete(`/api/connections/${connectionId}/`);
}

export const GetConnections = async () => {
    return await privateAxios.get(`/api/connections/`)
}

/** Connections that have at least one message or are accepted (for Messages panel so all chats appear). */
export const getConversations = async () => {
    return await privateAxios.get(`/api/connections/conversations/`)
}

export const GetOnlineConnections = async () => {
    return await privateAxios.get(`/api/connections/my-online-connected-users/`)
}

export const GetOfflineConnections = async () => {
    return await privateAxios.get(`/api/connections/my-offline-connected-users/`)
}

export const GetMutualConnections = async (withUserId = null) => {
    const params = withUserId != null ? { with_user_id: withUserId } : {}
    return await privateAxios.get(`/api/connections/mutual_connections/`, { params })
}

export const AcceptConnection = async (connectionId) => {
    return await privateAxios.patch(`/api/connections/${connectionId}/accept/`)
}

export const RejectConnection = async (connectionId) => {
    return await privateAxios.patch(`/api/connections/${connectionId}/reject/`)
}

export const GetPendingConnectionRequests = async () => {
    return await privateAxios.get(`/api/connections/pending_requests/`)
}

export const getConnectionPairStatus = async (otherUserId) => {
    return await privateAxios.get(`/api/connections/pair_status/`, {
        params: { other_user_id: otherUserId },
    })
}

export const FollowUser = async (followingUserId) => {
    return await privateAxios.post(`/api/connections/follows/follow/`, { following: followingUserId })
}

export const UnfollowUser = async (followingUserId) => {
    return await privateAxios.post(`/api/connections/follows/unfollow/`, { following: followingUserId })
}

export const GetFollowing = async () => {
    return await privateAxios.get(`/api/connections/follows/following/`)
}

export const GetFollowers = async () => {
    return await privateAxios.get(`/api/connections/follows/followers/`)
}

export const IsFollowing = async (userId) => {
    return await privateAxios.get(`/api/connections/follows/is_following/?user_id=${userId}`)
}

export const BlockUser = async (userId) => {
    return await privateAxios.post(`/api/connections/follows/block_user/`, { user_id: userId })
}

export const UnblockUser = async (userId) => {
    return await privateAxios.post(`/api/connections/follows/unblock_user/`, { user_id: userId })
}

export const GetUserDetails = async () => {
    return await privateAxios.get(`/api/users/me`)
}

export const GetSingleUserDetails = async (id = -1, role = '') => {
    return await privateAxios.get(`/api/users/${role}-profile/${id}`)
}

export const DeleteProfile = async () => {
    return await privateAxios.delete(`/api/users/me`)
}

export const DeactivateProfile = async (id) => {
    return await privateAxios.delete(`/api/users/${id}`)
}

export const UpdateAvatar = async (id, avatar_id) => {
    return await privateAxios.patch(`/api/users/${id}`, { avatar: avatar_id })
}

export const UpdateOnlineStatus = async (id, is_away = false) => {
    return await privateAxios.patch(`/api/users/${id}`, { is_away })
}

export const UpdateFavoriteList = async (id, favorites) => {
    return await privateAxios.patch(`/api/users/${id}`, { favorites })
}

export const GetDashboardDetails = async () => {
    return await privateAxios.get(`/api/landing-page`)
}

export const SearchUsers = async (query) => {
    return await privateAxios.get(`/api/users/?search=${query}`)
}

export const GetRecommendations = async (id) => {
    return await privateAxios.get(`/api/recommendations/?given_to=${id}`)
}

export const AddRecommendation = async (given_to, comment = '') => {
    return await privateAxios.post(`/api/recommendations/`, { comment, given_to })
}

export const UpdateRecommendation = async (id, given_to, comment = '') => {
    return await privateAxios.patch(`/api/recommendations/${id}/`, { comment, given_to })
}

export const DeleteRecommendation = async (id) => {
    return await privateAxios.delete(`/api/recommendations/${id}/`)
}

export const GetCompanyUsers = async ()=>{
    return await privateAxios.get('/api/users/company-users')
}

export const AddCompanyUser = async (data) => {
    return await privateAxios.post('/api/users/company-users', data)
}

export const UpdateCompanyUser = async (data)=>{
    return await privateAxios.put(`/api/users/company-users`, data)
}

export const DeleteCompanyUser = async (user_id)=>{
    return await privateAxios.delete(`/api/users/company-users`,{
        data: { user_id }
    })
}

export const TransferOwnership = async (user_id) => {
    return await privateAxios.post('/api/users/company-users/transfer-ownership', {
        user_id: user_id
    })
}

export const bindProfile = async () => {
  return await privateAxios.post('/api/profile/bind/');
};

export const unbindProfile = async () => {
  return await privateAxios.post('/api/profile/unbind/');
};

export const setDashboardActiveBucketJobs = async (jobIds) => {
  return await privateAxios.post('/api/profile/dashboard-active-bucket-jobs/', {
    job_ids: jobIds,
  });
};

export const setDashboardActiveBucketResumes = async (resumeIds) => {
  return await privateAxios.post('/api/profile/dashboard-active-bucket-resumes/', {
    resume_ids: resumeIds,
  });
};

export const getConnectionMessages = async (connectionId) => {
  return await privateAxios.get(`/api/connections/${connectionId}/messages/`);
};

export const sendConnectionMessage = async (connectionId, content) => {
  return await privateAxios.post(`/api/connections/${connectionId}/messages/`, { content });
};

export const markConnectionMessagesRead = async (connectionId) => {
  return await privateAxios.post(`/api/connections/${connectionId}/messages/read/`);
};

export const clearConnectionMessages = async (connectionId) => {
  return await privateAxios.delete(`/api/connections/${connectionId}/messages/`);
};

// Notes API functions
export const createNote = async (connectionId, content) => {
  return await privateAxios.post(`/api/connections/${connectionId}/notes/`, { content });
};

export const getNotes = async (connectionId, options = {}) => {
  const notes_scope = options.notesScope === 'pair' ? 'pair' : 'connection';
  return await privateAxios.get(`/api/connections/${connectionId}/notes/`, {
    params: { notes_scope },
  });
};

export const replyToNote = async (noteId, content, parentReplyId = null) => {
  const payload = { content };
  if (parentReplyId) {
    payload.parent_reply_id = parentReplyId;
  }
  return await privateAxios.post(`/api/connections/notes/${noteId}/replies/`, payload);
};

export const updateNote = async (noteId, content) => {
  return await privateAxios.patch(`/api/connections/notes/${noteId}/`, { content });
};

export const deleteNote = async (noteId) => {
  return await privateAxios.delete(`/api/connections/notes/${noteId}/`);
};

export const deleteNoteReply = async (replyId) => {
  return await privateAxios.delete(`/api/connections/notes/replies/${replyId}/`);
};

export const updateNoteReply = async (replyId, content) => {
  return await privateAxios.patch(`/api/connections/notes/replies/${replyId}/`, { content });
};

export const acknowledgeNote = async (noteId) => {
  return await privateAxios.post(`/api/connections/notes/${noteId}/acknowledge/`, {});
};

export const getMyNotes = async () => {
  return await privateAxios.get(`/api/connections/notes/my_notes/`);
};

export const reportNote = async (noteId, reason) => {
  return await privateAxios.post(`/api/connections/notes/${noteId}/report/`, { reason });
};

// Posts API
export const createPost = async (content) => {
  return await privateAxios.post(`/api/connections/posts/`, { content });
};

export const getPosts = async () => {
  return await privateAxios.get(`/api/connections/posts/`);
};

export const likePost = async (postId) => {
  return await privateAxios.post(`/api/connections/posts/${postId}/like/`);
};

export const unlikePost = async (postId) => {
  return await privateAxios.delete(`/api/connections/posts/${postId}/like/`);
};

export const replyToPost = async (postId, content, parentReplyId = null) => {
  return await privateAxios.post(`/api/connections/posts/${postId}/replies/`, { 
    content,
    parent_reply_id: parentReplyId 
  });
};

export const updatePost = async (postId, content) => {
  return await privateAxios.patch(`/api/connections/posts/${postId}/`, { content });
};

export const deletePost = async (postId) => {
  return await privateAxios.delete(`/api/connections/posts/${postId}/`);
};

export const deletePostReply = async (replyId) => {
  return await privateAxios.delete(`/api/connections/posts/replies/${replyId}/`);
};

export const updatePostReply = async (replyId, content) => {
  return await privateAxios.patch(`/api/connections/posts/replies/${replyId}/`, { content });
};

export const likePostReply = async (replyId) => {
  return await privateAxios.post(`/api/connections/posts/replies/${replyId}/like/`);
};

export const unlikePostReply = async (replyId) => {
  return await privateAxios.delete(`/api/connections/posts/replies/${replyId}/like/`);
};